import React, { useEffect, useState } from "react";
import TopHeader from "./components/common/TopHeader";
import ISOSelect from "./components/ISOSelect";
import { subscribeToRequests } from "./utils/requestTracker";
import LoadingOverlay from "./components/common/LoadingOverlay";

const BalDayDashboard = ({ iso }) => {
  const [Loading, setLoading] = useState(false)
  // Smart Loader
  useEffect(() => {
    const unsubscribe = subscribeToRequests((count) => {
      setLoading(count > 0);
    });
    return unsubscribe;
  }, []);

  return (
    <>
      <LoadingOverlay loading={Loading} setLoading={setLoading}/>
      <TopHeader appName="BalDay Dashboard" subCategory="Trading Analytics" />
      <ISOSelect iso={iso} />
    </>
  );
};

export default BalDayDashboard;
